// https://react-redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
import { AppDispatch } from "@store";
import { useDispatch } from "react-redux";

const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();

export default useAppDispatch;
